import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 text-white py-8 md:py-12 border-t border-navy-800" data-id="element-117">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-118">
        <h2 className="text-xl md:text-2xl font-display text-optic mb-3 md:mb-4" data-id="element-119">
          🎾 MEGAPACK TENIS RESUELTO™
        </h2>
        <p className="text-sm md:text-base text-gray-400 mb-6 md:mb-8 max-w-md mx-auto" data-id="element-120">
          El sistema de entrenamiento N°1 para entrenadores de tenis en
          Argentina.
          <br data-id="element-121" />
          <span className="text-white font-medium" data-id="element-122">
            Porque enseñar tenis no debería costarte todas las noches de la
            semana.
          </span>
        </p>

        <div className="flex flex-wrap justify-center items-center gap-2 md:gap-4 text-xs md:text-sm text-gray-400 mb-6 md:mb-8" data-id="element-123">
          <a href="mailto:contacto@recursosfitness.shop" className="hover:text-white transition-colors" data-id="element-124">
            contacto@recursosfitness.shop
          </a>
          <span className="text-navy-700" data-id="element-125">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-126">
            @recursosfitness.ar
          </a>
          <span className="text-navy-700" data-id="element-127">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-128">
            recursosfitness.shop
          </a>
        </div>

        <p className="text-[11px] md:text-xs text-gray-500" data-id="element-129">
          © RecursosFitness.shop™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}